import React from 'react';
import {
  Box,
  Grid,
  InputLabel,
  Paper,
  TextField,
  Typography,
} from '@material-ui/core';
import NumberInput from '../../../../components/NumberInput/NumberInput';
import StatusChipUnits from '../../../../components/StatusChip/StatusChipUnits';
import VppSelect from '../../../../components/select/VppSelect';
import SectionEditActions from './SectionEditActions';
import TenantReservedSpots from './TenantReservedSpots';

const EDITABLE_UNIT_STATUSES = ['active', 'blocked', 'suspended'];

const UnitsContactInformationBlock = ({
  inputRefs,
  fieldErrors,
  disabled,
  isEditing,
  onEdit,
  onCancel,
  onSave,
  showActions,
  submitDisabled,
  onChangeTenantNumber,
  onChangeGuestNumber,
  reservedSpots,
  getValues,
  setValue,
  control,
  unitStatus,
  statusSelectOptions,
  isUnitLoaded,
}) => {
  const normalizedStatus = String(unitStatus || '')
    .toLowerCase()
    .trim();
  const showStatusDropdown =
    isUnitLoaded &&
    isEditing &&
    normalizedStatus &&
    normalizedStatus !== 'archived' &&
    normalizedStatus !== 'pending' &&
    EDITABLE_UNIT_STATUSES.includes(normalizedStatus);

  return (
    <>
      <Paper elevation={0} variant="outlined">
        <Box
          p={3}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography variant="h5" color="primary">
            Contact information
          </Typography>
          <SectionEditActions
            isEditing={isEditing}
            onEdit={onEdit}
            onCancel={onCancel}
            onSave={onSave}
            showActions={showActions}
            submitDisabled={submitDisabled}
            editButtonId="contact_edit_button"
            saveButtonId="contact_save_button"
            cancelButtonId="contact_cancel_button"
          />
        </Box>
        <Box pt={0} px={3} pb={3}>
          <Grid container direction="row" spacing={4}>
            <Grid item xs={12} md={6} lg={3}>
              <InputLabel>
                <Typography variant="caption" color="textPrimary">
                  Name
                </Typography>
              </InputLabel>
              <TextField
                name="first_name"
                size="small"
                inputRef={inputRefs}
                disabled={disabled}
                error={!!fieldErrors.first_name}
                helperText={
                  fieldErrors.first_name ? fieldErrors.first_name : null
                }
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <InputLabel>
                <Typography variant="caption" color="textPrimary">
                  Last Name
                </Typography>
              </InputLabel>
              <TextField
                name="last_name"
                size="small"
                inputRef={inputRefs}
                disabled={disabled}
                error={!!fieldErrors.last_name}
                helperText={
                  fieldErrors.last_name ? fieldErrors.last_name : null
                }
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <InputLabel>
                <Typography variant="caption" color="textPrimary">
                  Phone number
                </Typography>
              </InputLabel>
              <TextField
                name="phone_number"
                size="small"
                inputRef={inputRefs}
                disabled={disabled}
                error={!!fieldErrors.phone_number}
                helperText={
                  fieldErrors.phone_number ? fieldErrors.phone_number : null
                }
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <InputLabel>
                <Typography variant="caption" color="textPrimary">
                  Email
                </Typography>
              </InputLabel>
              <TextField
                name="email"
                size="small"
                inputRef={inputRefs}
                disabled={disabled}
                error={!!fieldErrors.email}
                helperText={fieldErrors.email ? fieldErrors.email[0] : null}
                fullWidth
              />
            </Grid>
          </Grid>

          <Grid container alignItems="center" spacing={2} style={{ marginTop: 24 }}>
            <Grid item xs={12} md={4}>
              <Box display="flex" alignItems="center">
                <Box mr={3}>
                  <Typography variant="subtitle2" color="primary">
                    Permitted Vehicles:
                  </Typography>
                </Box>
                <NumberInput
                  id="tenant_vehicles_number"
                  name="tenant_vehicles_number"
                  size="small"
                  disabled={disabled}
                  onChange={onChangeTenantNumber}
                  inputRef={inputRefs}
                  error={!!fieldErrors.tenant_vehicles_number}
                  helperText={
                    fieldErrors.tenant_vehicles_number
                      ? fieldErrors.tenant_vehicles_number
                      : null
                  }
                />
              </Box>
            </Grid>
            <Grid item xs={12} md={4}>
              <Box display="flex" alignItems="center">
                <Box mr={3}>
                  <Typography variant="subtitle2" color="primary">
                    Permitted daily guest vehicles:
                  </Typography>
                </Box>
                <NumberInput
                  id="daily_guest_vehicles_number"
                  name="daily_guest_vehicles_number"
                  size="small"
                  disabled={disabled}
                  onChange={onChangeGuestNumber}
                  inputRef={inputRefs}
                  error={!!fieldErrors.daily_guest_vehicles_number}
                  helperText={
                    fieldErrors.daily_guest_vehicles_number
                      ? fieldErrors.daily_guest_vehicles_number
                      : null
                  }
                />
              </Box>
            </Grid>
            <TenantReservedSpots
              register={inputRefs}
              fieldErrors={fieldErrors}
              reservedSpots={reservedSpots}
              isEditMode={!disabled}
              setValue={setValue}
              getValues={getValues}
            />
            <Grid item xs={12} md={4}>
              <Box display="flex" alignItems="center">
                <Box mr={3}>
                  <Typography variant="subtitle2" color="primary">
                    Unit Status:
                  </Typography>
                </Box>
                {!isUnitLoaded || !normalizedStatus ? null : showStatusDropdown ? (
                  <VppSelect
                    key={`unit-status-${normalizedStatus}`}
                    id="unit_status_select"
                    name="status"
                    size="small"
                    control={control}
                    options={statusSelectOptions}
                    defaultValue={normalizedStatus}
                    disabled={false}
                  />
                ) : (
                  <StatusChipUnits status={normalizedStatus} />
                )}
              </Box>
              {fieldErrors.status ? (
                <Typography variant="caption" color="error">
                  {fieldErrors.status}
                </Typography>
              ) : null}
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </>
  );
};

export default UnitsContactInformationBlock;
